var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawermess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#265767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.98 18.79V22.79C25.98 23.05 25.97 23.3 25.94 23.54C25.71 26.24 24.12 27.58 21.19 27.58H20.79C20.54 27.58 20.3 27.7 20.15 27.9L18.95 29.5C18.42 30.21 17.56 30.21 17.03 29.5L15.83 27.9C15.7 27.73 15.41 27.58 15.19 27.58H14.79C11.6 27.58 10 26.79 10 22.79V18.79C10 15.86 11.35 14.27 14.04 14.04C14.28 14.01 14.53 14 14.79 14H21.19C24.38 14 25.98 15.6 25.98 18.79Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9902 22C17.4302 22 16.9902 21.55 16.9902 21C16.9902 20.45 17.4402 20 17.9902 20C18.5402 20 18.9902 20.45 18.9902 21C18.9902 21.55 18.5502 22 17.9902 22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4902 22C20.9302 22 20.4902 21.55 20.4902 21C20.4902 20.45 20.9402 20 21.4902 20C22.0402 20 22.4902 20.45 22.4902 21C22.4902 21.55 22.0402 22 21.4902 22Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22C13.94 22 13.5 21.55 13.5 21C13.5 20.45 13.95 20 14.5 20C15.05 20 15.5 20.45 15.5 21C15.5 21.55 15.05 22 14.5 22Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.98 14.79V18.79C29.98 21.73 28.63 23.31 25.94 23.54C25.97 23.3 25.98 23.05 25.98 22.79V18.79C25.98 15.6 24.38 14 21.19 14H14.79C14.53 14 14.28 14.01 14.04 14.04C14.27 11.35 15.86 10 18.79 10H25.19C28.38 10 29.98 11.6 29.98 14.79Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawermess);
export default __webpack_public_path__ + "static/media/drawermess.bcc0d46d5859a4f29eef9aaef9bf82d8.svg";
export { ForwardRef as ReactComponent };